import CookiePrivacyPolicyPopup from "@aus/Overrides/Components/CookiePrivacyPolicyPopup";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    container?: InjectableCss;
    footerPage?: InjectableCss;
    bottomFooterWrapper?: InjectableCss;
    bottomFooterZoneWrapper?: InjectableCss;
    preFooter?: InjectableCss;
    postFooter?: InjectableCss;
}

const styles: FooterStyles = {
    container: {
        css: css`
            background-color: ${getColor("primary.main")};
        `,
    },
    footerPage: {
        css: css`
            background-color: ${getColor("primary.main")};
        `,
    },
    bottomFooterWrapper: {
        css: css`
            background-color: ${getColor("primary.main")};
            width: 100%;
        `,
    },
    bottomFooterZoneWrapper: {
        css: css`
            max-width: 1700px;
            margin: auto;
            padding: 15px;
        `,
    },
    preFooter: {
        css: css`
            background-color: ${getColor("primary.main")};
            height: 10px;
            border-top: solid 5px #616161;
        `,
    },
    postFooter: {
        css: css`
            background-color: ${getColor("primary.contrast")};
            height: 2px;
        `,
    },
};

const Footer: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <StyledWrapper {...styles.container}>
        <StyledWrapper {...styles.preFooter} />
        <Zone contentId={id} zoneName="TopFullWidthFooter" />
        <Page as="footer" style={{ paddingTop: 25 }} isFooter={true} {...styles.footerPage}>
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
        <StyledWrapper {...styles.postFooter} />
        <StyledWrapper {...styles.bottomFooterWrapper}>
            <StyledWrapper {...styles.bottomFooterZoneWrapper}>
                <Zone contentId={id} zoneName="BottomFullWidthFooter" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
